<template>
  <OrderPackingDetail label="Restock" :with-fee="false" pengemasan-path="gudang.pengeluaran.barang-ke-kp.pengemasan" :index-path="{ name: 'gudang.pengeluaran.barang-ke-kp' }" />
</template>

<script>
import OrderPackingDetail from '../../../../../components/order/OrderPackingDetail.vue';

export default {
  components: { OrderPackingDetail }
}
</script>